import { ActivationState, ClassRegisterApiFactory } from '../../api/v2';
import { MNSproCloudApi, TimePattern } from '../..';
import {
  timePatternResponseToTimePattern,
  timePatternToTimePatternRequest,
  timePatternToTimePatternRequestWithId,
} from '../../../utils/mappings/timePatternMappings';

const options = {
  validateStatus: (status: number) =>
    (status >= 200 && status <= 299) || status === 404,
};

const generateApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  return ClassRegisterApiFactory(config);
};

export class TimepatternSettingsService {
  static async getActiveTimepattern(
    authToken: string,
    organizationId: string,
  ): Promise<TimePattern> {
    const api = generateApi(authToken);
    const result = await api.getTheActiveTimePattern(
      organizationId,
      undefined,
      options,
    );

    return timePatternResponseToTimePattern(result.data);
  }

  static async createTimepattern(
    authToken: string,
    organizationId: string,
    pattern: TimePattern,
  ): Promise<TimePattern> {
    const api = generateApi(authToken);
    const result = await api.createTimePattern(
      organizationId,
      timePatternToTimePatternRequest(pattern),
      undefined,
      options,
    );

    return timePatternResponseToTimePattern(result.data);
  }

  static async updateTimepattern(
    newPattern: TimePattern,
    authToken: string,
    organizationId: string,
  ) {
    const api = generateApi(authToken);
    const response = await api.updateTimePattern(
      organizationId,
      timePatternToTimePatternRequestWithId(newPattern),
      undefined,
      options,
    );
    return timePatternResponseToTimePattern(response.data);
  }

  static async setActivationState(
    authToken: string,
    organizationId: string,
    id: string,
    active: boolean,
  ) {
    const api = generateApi(authToken);
    const response = await api.changeTimePatternActivationState(
      organizationId,
      id,
      active ? ActivationState.activate : ActivationState.deactivate,
    );
    return timePatternResponseToTimePattern(response.data);
  }

  static async getAllTimepattern(
    authToken: string,
    organizationId: string,
  ): Promise<TimePattern[]> {
    const api = generateApi(authToken);
    const result = await api.getAllTimePatterns(
      organizationId,
      undefined,
      options,
    );

    return result.data.map(timePatternResponseToTimePattern);
  }

  static async deleteTimepattern(
    patternId: string,
    authToken: string,
    organizationId: string,
  ): Promise<void> {
    const api = generateApi(authToken);
    await api.deleteTimePattern(organizationId, patternId, undefined, options);
  }
}
